import { z } from "zod";

/**
 * `VibeTemplate.defaultEnvVarsJson` shape — a flat `Record<string, string>`
 * of env-var names to default values. The CLI surfaces these on
 * `vibe init`; the user can opt out per var before the new app's env
 * registry is seeded.
 *
 * Schema constraints are deliberately permissive:
 *   - keys are SCREAMING_SNAKE_CASE per env-var convention (same regex
 *     as the env-var slice)
 *   - values are strings (no nesting, no arrays, no nulls) — env vars
 *     are strings at the process boundary anyway
 *   - empty object is valid: a template with no env wiring is the most
 *     common case
 */
export const VIBE_TEMPLATE_ENV_VAR_NAME_REGEX = /^[A-Z][A-Z0-9_]*$/;

export const VibeTemplateDefaultEnvVarsSchema = z
  .record(
    z.string().regex(VIBE_TEMPLATE_ENV_VAR_NAME_REGEX, {
      message:
        "env var name must be SCREAMING_SNAKE_CASE (start with a letter, A–Z, 0–9, underscore only)"
    }),
    z.string()
  )
  .default({});

export type VibeTemplateDefaultEnvVars = z.infer<typeof VibeTemplateDefaultEnvVarsSchema>;
